import { _AuthApi } from "api/auth";
import { Navigate, Outlet } from "react-router-dom";

const ShouldNotBeLogged = () => {
  if (_AuthApi.getToken()) return <Navigate to="/dashboard" />;
  return <Outlet />;
};

export default ShouldNotBeLogged;
